import { c as _c } from "react/compiler-runtime";
import { useQueries } from '@tanstack/react-query';
import { createSubscriberQueryFn, getSubscriberQueryMetaOptions } from './subscriber-query-fn.js';
/**
 * Pins finite-retention entities while an active list index references them.
 * These cache-only observers never fetch or notify the component; removing an
 * id detaches its observer and lets TanStack's finite GC window start.
 */
export function useRetainNormalizedEntityReferences(queryClient, entityQueryKey, ids, gcTimeMs) {
  const $ = _c(7);
  let t0;
  if ($[0] !== entityQueryKey || $[1] !== gcTimeMs || $[2] !== ids || $[3] !== queryClient) {
    t0 = gcTimeMs === undefined ? [] : ids.map(id => {
      const queryKey = entityQueryKey(id);
      return {
        queryKey,
        queryFn: createSubscriberQueryFn(queryClient, queryKey),
        enabled: false,
        staleTime: Number.POSITIVE_INFINITY,
        gcTime: gcTimeMs,
        notifyOnChangeProps: [],
        ...getSubscriberQueryMetaOptions(queryClient, queryKey)
      };
    });
    $[0] = entityQueryKey;
    $[1] = gcTimeMs;
    $[2] = ids;
    $[3] = queryClient;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  let t1;
  if ($[5] !== t0) {
    t1 = {
      queries: t0
    };
    $[5] = t0;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  useQueries(t1);
}